import * as swcHelpers from '@swc/helpers';

var ref, _gross;
const getEnrichedBundleChildLineItems = ({ lineItem , addOnLabel , isReadOnly =true , actionLabel , actionCallback  })=>{
    var ref2, ref1;
    return [
        ...'bundleChildLineItems' in lineItem && lineItem.bundleChildLineItems ? lineItem.bundleChildLineItems : [],
        ...lineItem.insurance ? [
            swcHelpers.objectSpread({
                title: addOnLabel,
                body: (ref = (ref2 = lineItem.insurance.name[0]) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref !== void 0 ? ref : '',
                price: (_gross = (ref1 = lineItem.insurance.price) === null || ref1 === void 0 ? void 0 : ref1.unit.gross) !== null && _gross !== void 0 ? _gross : 0,
                sku: lineItem.insurance.sku
            }, !isReadOnly && actionLabel && actionCallback ? {
                action: {
                    text: actionLabel,
                    onClick: ()=>actionCallback(lineItem)
                }
            } : null), 
        ] : [], 
    ];
};

export { getEnrichedBundleChildLineItems };
//# sourceMappingURL=get-enriched-bundle-child-line-items.js.map
